"use strict";

var _createClass = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/createClass");

var _classCallCheck = require("C:\\Users\\mrcax\\WebstormProjects\\hth\\node_modules\\@babel\\runtime/helpers/classCallCheck");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var util_1 = require("util");

var ColorCodes = function ColorCodes() {
  _classCallCheck(this, ColorCodes);
};

ColorCodes.RED = '\x1b[31m';
ColorCodes.CYAN = '\x1b[36m';
ColorCodes.YELLOW = '\x1b[33m';
ColorCodes.RESET = '\x1b[0m';

var ConsoleLogger =
/*#__PURE__*/
function () {
  function ConsoleLogger() {
    _classCallCheck(this, ConsoleLogger);
  }

  _createClass(ConsoleLogger, [{
    key: "log",
    value: function log(prefix, data) {
      this.prepareLog(ColorCodes.CYAN, 'log', prefix, data);
    }
  }, {
    key: "warn",
    value: function warn(prefix, data) {
      this.prepareLog(ColorCodes.YELLOW, 'warn', prefix, data);
    }
  }, {
    key: "error",
    value: function error(prefix, data) {
      this.prepareLog(ColorCodes.RED, 'error', prefix, data);
    }
  }, {
    key: "prepareLog",
    value: function prepareLog(color, tag, prefix, data) {
      var time = new Date().toTimeString().replace(/.*(\d{2}:\d{2}:\d{2}).*/, '$1');
      process.stdout.write("".concat(time, " ").concat(color, "[").concat(tag, "]").concat(ColorCodes.RESET, " ").concat(prefix, " ").concat(util_1.format(data || ''), " \n"));
    }
  }]);

  return ConsoleLogger;
}();

exports.ConsoleLogger = ConsoleLogger;